import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "../../components/ui/button";
import SelectField from "../../components/ui/SelectField";
import { toast } from "react-toastify";
import CaracteristicaForm from "../../components/modals/CaracteristicaForm";
import { LoaderPinwheel } from "lucide-react";
import { hasPermission } from "../../utils/permissions";

const GRUPOS = [
  "Biomédico",
  "Laboratorio",
  "Industrial",
  "Computo",
  "Impresión",
  "Digitalización",
];

const CaracteristicasEquipoPage = () => {
  const [grupo, setGrupo] = useState("");
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState(null);

  // 🔄 flag para forzar recarga
  const [reload, setReload] = useState(false);

  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  /* ---------------- CARGA CARACTERÍSTICAS POR GRUPO ---------------- */
  const fetchItems = async () => {
    if (!grupo) {
      setItems([]);
      return;
    }

    try {
      setLoading(true);

      const res = await axios.get(
        `${API}/categoria-caracteristicas/grupo/${grupo}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setItems(res.data);
    } catch (err) {
      toast.error("Error cargando características");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
    // eslint-disable-next-line
  }, [grupo, reload]);

  return (
    <div className="space-y-4">
      {/* Selector de grupo + botón */}
      <div className="flex flex-col sm:flex-row gap-4 justify-between items-end">
        <SelectField
          label="Grupo"
          name="grupo"
          value={grupo}
          onChange={(e) => setGrupo(e.target.value)}
          options={GRUPOS.map((g) => ({ _id: g, name: g }))}
        />
        {hasPermission("caracteristicas.crear") && (
          <Button
            disabled={!grupo}
            onClick={() => {
              setEditItem(null);
              setOpenForm(true);
            }}
          >
            + Nueva característica
          </Button>
        )}
      </div>

      {loading && (
        <div className="mb-4 flex items-center gap-2 rounded-lg border border-blue-100 bg-blue-50 px-3 py-2 text-sm text-blue-700">
          <LoaderPinwheel className="h-4 w-4 animate-spin text-blue-600" />
          Cargando datos, por favor espera...
        </div>
      )}

      {/* LISTADO */}
      <div className="border rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 text-left">Nombre</th>
              <th>Tipo</th>
              <th>Requerido</th>
              <th>Filtrable</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c._id} className="border-t">
                <td className="p-2">{c.nombre}</td>
                <td className="text-center">{c.tipo}</td>
                <td className="text-center">{c.requerido ? "Sí" : "No"}</td>
                <td className="text-center">{c.filtrable ? "Sí" : "No"}</td>
                <td className="text-right p-2">
                  {hasPermission("caracteristicas.editar") && (
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setEditItem(c);
                        setOpenForm(true);
                      }}
                    >
                      Editar
                    </Button>
                  )}
                </td>
              </tr>
            ))}

            {!items.length && grupo && (
              <tr>
                <td colSpan={5} className="text-center p-4 text-gray-500">
                  No hay características registradas para este grupo
                </td>
              </tr>
            )}

            {!grupo && (
              <tr>
                <td colSpan={5} className="text-center p-4 text-gray-400">
                  Selecciona un grupo para ver sus características
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {openForm && (
        <CaracteristicaForm
          grupo={grupo}
          data={editItem}
          onClose={() => setOpenForm(false)}
          onSaved={() => {
            setOpenForm(false);
            setEditItem(null);
            setReload((r) => !r); // 🔄 fuerza recarga
          }}
        />
      )}
    </div>
  );
};

export default CaracteristicasEquipoPage;
